<script>
import { mapActions } from "vuex";
import ClientFactory from "@/api/ClientFactory";
import ListFile from "../../../components/files/ListFile";
const api = ClientFactory.get("briefings");
const briefingDrafApi = ClientFactory.get("briefingDraft");
import { VueGoodTable } from "vue-good-table";

export default {
  components: {
    VueGoodTable,
    ListFile,
  },
  data() {
    return {
      state: {
        dialog: {
          files: false,
        },
        deleteId: -1,
      },

      file_data: [],
      inputYear: new Date().getFullYear(),
      inputMonth: new Date().getMonth() + 1,
      listReport: [],
      tableReportData: [],
      tableConclusionData: [],
      tableDraftConclusionData: [],
    };
  },
  computed:{
    months() {
        return [
            {
                label: "Tháng 1",
                value: 1,
            },
            {
                label: "Tháng 2",
                value: 2,
            },
            {
                label: "Tháng 3",
                value: 3,
            },
            {
                label: "Tháng 4",
                value: 4,
            },
            {
                label: "Tháng 5",
                value: 5,
            },
            {
                label: "Tháng 6",
                value: 6,
            },
            {
                label: "Tháng 7",
                value: 7,
            },
            {
                label: "Tháng 8",
                value: 8,
            },
            {
                label: "Tháng 9",
                value: 9,
            },
            {
                label: "Tháng 10",
                value: 10,
            },
            {
                label: "Tháng 11",
                value: 11,
            },
            {
                label: "Tháng 12",
                value: 12,
            },
        ]
    },
    reportcolumns() {
      return [
        {
          label: "Nội dung báo cáo",
          field: "report_title",
          sortable: false,
        },
        {
          label: "Phòng ban",
          field: "department_name",
          sortable: false,
          width: "280px",
        },
        {
          label: "File đính kèm",
          field: "file",
          width: "280px",
          sortable: false,
        },
      ]
    },
    columns() {
      return [
        {
          label: "Nội dung báo cáo",
          field: "content",
          sortable: false,
        },
        {
          label: "File đính kèm",
          field: "file",
          width: "280px",
          sortable: false,
        },
      ]
    }
},
  methods: {
    ...mapActions("ui", ["loading", "closeLoading", "notify"]),
    async getData() {
      this.loading(this.$vs);
      ({data: {data: this.tableReportData}} = await api.searchReport("", this.inputMonth, this.inputYear, ""));
      const {data} = await api.searchConclusion("", this.inputMonth, this.inputYear, "");
      
      this.tableConclusionData = data.data;
      const dataDraftConclusion= await briefingDrafApi.search(this.inputMonth, this.inputYear);

      this.tableDraftConclusionData = dataDraftConclusion.data.data;
      this.closeLoading();
    },
    async downloadSummary() {
      this.loading(this.$vs);
      const response = await api.exportReport(this.inputMonth, this.inputYear);
      this.closeLoading();

      if (typeof response === "undefined" || response.status === "failed") {
        return this.notify({
          error: true,
          text: response.message || "Unknow error",
        });
      }
      //console.log(response);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `tong_hop_giao_ban.xlsx`);
      link.click();
      window.URL.revokeObjectURL(url);
    },
    async displayFileReport(report) {
      this.loading(this.$vs);
      const {status, data} = await api.getfileReport(report.id);
      if (status == "success") {
          this.file_data = data.map(f => {
              return {
                  file_name: f.file_name,
                  file_url: f.file_path
              }
          })
      } else {
          this.file_data = []
      }
      //show dialog
      this.closeLoading();
      this.state.dialog.files = true;
    },

    async displayFileConclusion(report) {
      this.loading(this.$vs);
      const {status, data} = await api.getfileConclusion(report.id);
      if (status == "success") {
          this.file_data = data.map(f => {
              return {
                  file_name: f.file_name,
                  file_url: f.file_path
              }
          })
      } else {
          this.file_data = []
      }
      //show dialog
      this.closeLoading();
      this.state.dialog.files = true;
    },
    async displayFileDraftConclusion(report) {
      this.loading(this.$vs);
      const {status, data} = await briefingDrafApi.getAttachments(report.id);
      if (status == "success") {
          this.file_data = data.map(f => {
              return {
                  file_name: f.file_name,
                  file_url: f.file_path
              }
          })
      } else {
          this.file_data = []
      }
      //show dialog
      this.closeLoading();
      this.state.dialog.files = true;
    },
  },
  async created() {
    await this.getData();
  },
  destroyed() {
    this.closeLoading();
  },
};
</script>
<template>
  <div id="briefing-summary">
    <CCard class="mb-2">
      <CCardHeader class="pt-1 pb-1">
        <span class="card-header-title">Tổng hợp giao ban tháng</span>
      </CCardHeader>
      <CCardBody class="pt-1 pb-1">
        <CRow class="mb-2">
          <CCol sm="3" />
          <CCol sm="2">
            <label class="mb-1">Năm</label>
            <CInput v-model="inputYear" type="number" />
          </CCol>
          <CCol sm="2">
            <label class="mb-1">Tháng</label>
            <CSelect
              :value.sync="inputMonth"
              :options="months"
              @change="getData"
            />
          </CCol>
          <CCol sm="2">
            <label class="mb-0">&nbsp;</label>
            <vs-button warn square class="custom_btn_search" @click="getData">
              <i class="bx bx-search"></i>&nbsp;Hiển thị</vs-button>
          </CCol>
          <CCol sm="3" />
        </CRow>
      </CCardBody>
    </CCard>
    <CCard class="p-2 mb-0">
      <span class="card-header-title">Nội dung mục họp giao ban</span>
      <CCard class="mb-2">
        <CCardHeader>
          <span class="category-title">1. Báo cáo các phòng</span>
        </CCardHeader>
        <CCardBody>
          <vue-good-table
            :columns="reportcolumns"
            :rows="tableReportData"
            compactMode
            styleClass="vgt-table bordered striped"
            :line-numbers="true"
            :pagination-options="{
              enabled: false,
              perPageDropdownEnabled: false,
              nextLabel: 'Trang sau',
              prevLabel: 'Trang trước',
              ofLabel: 'của',
            }"
          >
            <div
              slot="emptystate"
              style="margin-top: 10px; margin-bottom: 10px"
            >
              Không có dữ liệu
            </div>
            <template slot="table-row" slot-scope="props">
              <div v-if="props.column.field === 'file'">
                <vs-tooltip color="square">
                  <vs-button
                    transparent
                    @click="displayFileReport(props.row)"
                    square
                    circle
                    icon
                    ><i class="bx bxs-file"></i
                  ></vs-button>
                  <template #tooltip>
                    Xem file đính kèm
                  </template>
                </vs-tooltip>
              </div>
            </template>
          </vue-good-table>
        </CCardBody>
      </CCard>
      <CCard class="mb-2">
        <CCardHeader>
          <span class="category-title"
            >2. Tổng hợp báo cáo và dự thảo kết luận giao ban</span
          >
        </CCardHeader>
        <CCardBody>
          <vue-good-table
            :columns="columns"
            :rows="tableDraftConclusionData"
            compactMode
            styleClass="vgt-table bordered striped"
            :line-numbers="true"
            :pagination-options="{
              enabled: false,
              perPageDropdownEnabled: false,
              nextLabel: 'Trang sau',
              prevLabel: 'Trang trước',
              ofLabel: 'của',
            }"
          >
            <div
              slot="emptystate"
              style="margin-top: 10px; margin-bottom: 10px"
            >
              Không có dữ liệu
            </div>
            <template slot="table-row" slot-scope="props">
              <div v-if="props.column.field === 'file'">
                <vs-tooltip color="square">
                  <vs-button
                    transparent
                    @click="displayFileDraftConclusion(props.row)"
                    square
                    circle
                    icon
                    ><i class="bx bxs-file"></i
                  ></vs-button>
                  <template #tooltip>
                    Xem file đính kèm
                  </template>
                </vs-tooltip>
              </div>
            </template>
          </vue-good-table>
        </CCardBody>
      </CCard>
      <CCard class="mb-0">
        <CCardHeader>
          <span class="category-title">3. Kết luận giao ban</span>
        </CCardHeader>
        <CCardBody>
          <vue-good-table
            :columns="columns"
            :rows="tableConclusionData"
            compactMode
            styleClass="vgt-table bordered striped"
            :line-numbers="true"
            :pagination-options="{
              enabled: false,
              perPageDropdownEnabled: false,
              nextLabel: 'Trang sau',
              prevLabel: 'Trang trước',
              ofLabel: 'của',
            }"
          >
            <div
              slot="emptystate"
              style="margin-top: 10px; margin-bottom: 10px"
            >
              Không có dữ liệu
            </div>
            <template slot="table-row" slot-scope="props">
              <div v-if="props.column.field === 'file'">
                <vs-tooltip color="square">
                  <vs-button
                    transparent
                    @click="displayFileConclusion(props.row)"
                    square
                    circle
                    icon
                    ><i class="bx bxs-file"></i
                  ></vs-button>
                  <template #tooltip>
                    Xem file đính kèm
                  </template>
                </vs-tooltip>
              </div>
            </template>
          </vue-good-table>
        </CCardBody>
      </CCard>
    </CCard>
    <CRow>
      <CCol sm="12" class="center">
        <vs-button success square @click="downloadSummary()">
          <i class="bx bxs-download"></i>&nbsp;Tải về</vs-button
        >
      </CCol>
    </CRow>

    <vs-dialog prevent-close width="650px" v-model="state.dialog.files">
      <ListFile :file_data="this.file_data" />
    </vs-dialog>
  </div>
</template>

<style lang="scss">
#briefing-summary {
  table.vgt-table td {
    vertical-align: inherit;
    color: black !important;
    font-size: 14.5px;
    //padding: 0.3rem !important;
    padding: 0em 0.75em 0em 0.75em;
  }
  .vgt-responsive {
    overflow-x: inherit;
  }
  .category-title {
    font-size: 17px;
    font-weight: 600;
  }
  .attachment_file_label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 260px;
    display: inline-block;
  }
}
</style>
